import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { UtilisateurService } from './utilisateur.service';
import { OrganisationModel } from 'src/models/pilotage/organisationModel';

@Injectable({
  providedIn: 'root'
})
export class ParametreEntiteService {
  private baseUrl = environment.api_LMS + 'ParametreEntite';
constructor(private http: HttpClient, private utilisateurService: UtilisateurService) { }

 obtenirDonnesEntites(): Observable<OrganisationModel[]> {
  const entiteId = this.utilisateurService.entiteUtilisateurSelectionnee.entiteId;
    return this.http.get<OrganisationModel[]>(`${this.baseUrl}/ObtenirDonnesEntites`, { params: { entiteId: entiteId.toString() } });
  }

  MiseAJourNom(organisationModel: OrganisationModel): Observable<void> {
    return this.http.put<void>(
      `${this.baseUrl}/MiseAJourNom`,  organisationModel
    );
  }

}
